<template>
  <v-layout class="home">
    <Topics/>
  </v-layout>
</template>

<script>
// @ is an alias to /src
import Topics from '@/components/normal-user/TopicsNormalUser.vue'

export default {
  name: 'Home',
  components: {
    Topics
  }
}
</script>
